module.exports = __webpack_public_path__ + "img/Default.8f338988.svg";